export const IS_DEV = true; // informational logging will be done when true
export const IS_DUMMY = false;

export const APPNAME = "SpotTrek"; // application name
//export const API_BASE = "http://localhost:8888"; // backend service base URL
export const API_BASE = "https://stgspottrekapi.barcindia.in";
//export const API_BASE = "https://spottrek-stg-api.barcindia.net"; // backend service base URL
//export const API_BASE = "https://stgspottrekapi.barcindia.in"; // backend service base URL
export const APPVER = "14-01-2025";
export const VKEY = "VAPTPOINTSGTGGTNHYTRE1234567";
// user types
export const USER_SUPERADMIN = 1;
export const USER_BUSINESS_ADMIN = 2;
export const USER_OPS = 3;
export const USER_CLIENT_ADMIN = 5;
export const USER_CLIENT_ENDUSER = 6;
export const USER_CLIENT_MANAGER = 7;

export const INTERNAL_USERS = [USER_SUPERADMIN, USER_BUSINESS_ADMIN, USER_OPS];
export const CLIENT_USERS = [USER_CLIENT_ADMIN, USER_CLIENT_ENDUSER];

// user types reverse
export const USER_TYPE_REVERSE = {
  1: "Super Admin",
  2: "Business Admin",
  3: "Operations",
  4: "Client Super Admin",
  5: "Client Admin",
  6: "Client End User",
  7: "Client Manager",
};

// master types
export const MASTER_ADVERTISER = 1;
export const MASTER_BRAND = 2;
export const MASTER_CHANNEL = 3;

// client types
export const CLIENT_ADVERTISER = 1;
export const CLIENT_BROADCASTER = 2;
export const CLIENT_AGENCY = 3;
export const CLIENT_OTHERS = 4;

// client type reverse
export const CLIENT_TYPE_REVERSE = {
  1: "Advertiser",
  2: "Broadcaster",
  3: "Agency",
  4: "Others",
};

// client types reverse
export const CLIENT_TYPES = {
  1: "Advertiser",
  2: "Broadcaster",
  3: "Agency",
  4: "Other",
};

// content types
export const CONTENT_TYPES = {
  0: "All",
  102: "Promo",
  103: "Commercial",
  105: "ICA",
};


// content types reverse
export const CONTENT_TYPE_REVERSE = {
  All: 0,
  Promo: 102,
  Commercial: 103,
  Program: 101,
  Ica: 105,
};

// billing statuses
export const BILLING_STATUSES = {
  0: "Generated",
  1: "Completed",
};

export const BILLING_STATUSES_REVERSE = {
  Generated: 0,
  Compelted: 1,
};

// subscription statuses
export const SUB_STATUSES = {
  BARC_REJECTED: -2,
  CLIENT_REJECTED: -1,
  PENDING: 0,
  PARTIAL_APPROVED: 1,
  APPROVED: 2,
};

// subscription statuses reverse
export const SUB_STATUSES_REVERSE = {
  "-2": "BARC Rejected",
  "-1": "Client Rejected",
  0: "Pending",
  1: "Partial Approved",
  2: "Approved",
};

// subscription modification type
export const SUB_MODIFY_TYPES = {
  SHORT_CLOSE: 1,
  EXTEND: 2,
};

// subscription modification type reverse
export const SUB_MODIFY_TYPES_REVERSE = {
  1: "Short Close",
  2: "Extend",
};

// client contact types
export const CLIENT_CONTACT_TYPES = {
  MAIL_AUTHORITY: 1,
  SPOC: 2,
};

// client contact types reverse
export const CLIENT_CONTACT_TYPES_REVERSE = {
  1: "Mail Authority",
  2: "SPOC",
};

// file statuses
export const FILE_STATUSES = {
  PROCESS: 1,
  COMPLETED: 2,
  ERROR: 3,
};

// file statuses reverse
export const FILE_STATUSES_REVERSE = {
  1: "Processing",
  2: "Completed",
  3: "Error",
};

// file types
export const FILE_TYPES = {
  FILE_MASTER: 1,
  FILE_PLAYOUT: 2,
};

// file type reverse
export const FILE_TYPES_REVERSE = {
  1: "Master",
  2: "Playout",
};

// page permissions constants
export const PAGE_PERMISSIONS = {
  PERM_CHANNEL_MASTER: 1,
  PERM_BRAND_MASTER: 2,
  PERM_PROGRAM_MASTER: 3,
  PERM_GENRE_MASTER: 4,
  PERM_PROMO_MASTER: 5,
  PERM_CONTENT_LANGUAGE_MASTER: 6,
  PERM_USER_MASTER: 7,

  PERM_DASHBOARD_MENU: 8,
  PERM_REPORTS_MENU: 9,
  PERM_MASTERS_MENU: 10,
  PERM_USER_MANAGEMENT_MENU: 11,
  PERM_SUBSCRIPTION_MENU: 12,
  PERM_BILLING_MENU: 13,
  PERM_CLIENTS_MENU: 14,
  PERM_QUERY_SUPPORT_MENU: 15,
  PERM_FILE_DETAILS_MENU: 16,
  PERM_ACTIVITY_TRACKER_MENU: 17,
  PERM_QUERY_EXECUTOR_MENU: 18,

  PERM_GROUP_ADVERTISER_MANAGE: 19,
  PERM_GROUP_LISTING: 20,
  PERM_CLIENT_LISTING: 21,
  PERM_CREATE_CLIENT: 22,
  PERM_LOGIN_TRACKER: 23,
  PERM_SUBSCRIPTION_LISTING: 24,
  PERM_SUBSCRIPTION_CREATE: 25,

  PERM_MONITORING_REPORT: 26,
  PERM_ADHOC_REPORT: 27,
  PERM_FEED_MISSING_REPORT: 28,
  PERM_SUMMARY_REPORT: 29,

  PERM_NOTIFICATIONS: 30,
  PERM_ACCOUNT_MANAGERS: 31,
  PERM_BILLING_RATE_CARD: 32,
  PERM_BILLING_LISTING: 33,
  PERM_CLIENT_RE_LISTING: 34,
  GROUP_CLIENT_RENEW_LIST: 35,
};
////  PERM_BILLING_LISTING: '',
// PERM_BILLING_RATE_CARD: 32,
export const FS_LOADER_FADE_TIME = 1600; // full page loader default time
export const USER_LOGGED = 1;
export const NO_USER = -1;
export const USER_FIRST_LOGIN = 2;

// Local data related
export const LS_NAME = "st"; // database name for WebSQL
export const LS_STORE = "st_store"; // store name for WebSQL
export const LS_AUTH_TOKEN_KEY = "bYdHnKJUIklrsjw"; // key for storing auth tokens in WebSQL
export const LS_REFRESH_TOKEN_KEY = "bYdHnKJUIklrsjwm";
export const LS_LAST_DATA_DATE = "hjturyi";
export const LS_PRIMARY_COLOR = "theme_primary_color";
export const LS_CLONE_SUB_KEY = "clone_sub";
export const LS_CLONE_CLIENT_KEY = "clone_client";
export const LS_CLONE_REGROUP_KEY = "clone_renew_client";
export const LS_NAME_REGROUP_NAME = "clone_renew_group_name";
// API Constants
export const APIS = {
  last_data: "last_data",
  get_account_managers: "masters/account-manager",
};

// Auth related constants
export const SPKI =
  "-----BEGIN PUBLIC KEY-----MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA0rCJSEFDogbLuqsNOUNABOayhDQ9MZowbGbPnyuuUrXZRjSFNXia7WNB6HwU1FEyR22w4oE5Gpf0r6bwbXQTc8tSPTJI8xVcXjuQA+18cY3v0oWN7VEmjt9GngYmUCs3YPlpRW9msVTyhJ7NbKoaiJQEvH4CtF1bahAqHzP4iQzmXkRxa7fX83P4eJqW0KrfNsw6tDlLeDYR0pt0kQdtB3OrY2IIB0Fn+1jKK0ptGIx4BbtkCwK3KrKT84dgv2iLj6W1+f8eK7ccTdlye4pSSVD2mukghppvb1mxXHO6T9rBVlYcLOQAnoNb4USgHyfmsQS4XvPlz225gq8P+H0+Z5/kk6jIBCKJtvXLN8tM/SEwEqelm2pJkubYu9uZGa7iv3WymRICtJ1VfeKcaQx2rEf9iOHv4zmdSKDbDisO14Aal6EKklPNANB75OiGqtxXwNSy/s1Zr1gMrs0L5oD0i0ie5u3nCtUkrOJgqBuy8BoPb2ZOyP9zvMydLBuaH4oklMI/UqZnjuyS7jWp1Pk7vjtHMxU9Q427tE4WU/FtrlCcYToj2WIvkMFxtSqw8nXkDuPPPlLJq3kJzwvmC3m4qFmqo0149NRuzlBNTzUfA5aBgR5C1AEu+qgAwz9Pu2Yi+DMFuOaLNY3c6ryJ/cYC0rKZK7t5h8isRSbQgpZN9ZUCAwEAAQ==-----END PUBLIC KEY-----";
export const TOKEN_ISSUER = "barcindia.spotTrek.auth";
export const TOKEN_ALGO = "RS256";

export const MENUS_PERMISSION_MAP = [
  {
    item: "Dashboard Menu",
    pathname: "/dashboard",
    permission: PAGE_PERMISSIONS.PERM_DASHBOARD_MENU,
    subMenus: [],
  },
  {
    item: "Reports Menu",
    pathname: "/reports",
    permission: PAGE_PERMISSIONS.PERM_REPORTS_MENU,
    subMenus: [
      {
        item: "Monitoring",
        pathname: "/reports/monitoring",
        permission: PAGE_PERMISSIONS.PERM_MONITORING_REPORT,
      },
      {
        item: "AdHoc",
        pathname: "/reports/adhoc",
        permission: PAGE_PERMISSIONS.PERM_ADHOC_REPORT,
      },
      {
        item: "Summary",
        pathname: "/reports/summary",
        permission: PAGE_PERMISSIONS.PERM_SUMMARY_REPORT,
      },
      {
        item: "Feed Missing",
        pathname: "/reports/feedmissing",
        permission: PAGE_PERMISSIONS.PERM_FEED_MISSING_REPORT,
      },
    ],
  },
  {
    item: "Masters Menu",
    pathname: "/masters",
    permission: PAGE_PERMISSIONS.PERM_MASTERS_MENU,
    subMenus: [
      {
        item: "Brand",
        pathname: "/masters/brand",
        permission: PAGE_PERMISSIONS.PERM_BRAND_MASTER,
      },
      {
        item: "Channel",
        pathname: "/masters/channel",
        permission: PAGE_PERMISSIONS.PERM_CHANNEL_MASTER,
      },
      {
        item: "Content Langauge",
        pathname: "/masters/language",
        permission: PAGE_PERMISSIONS.PERM_CONTENT_LANGUAGE_MASTER,
      },
      {
        item: "Genre",
        pathname: "/masters/genre",
        permission: PAGE_PERMISSIONS.PERM_GENRE_MASTER,
      },
      {
        item: "Program",
        pathname: "/masters/program",
        permission: PAGE_PERMISSIONS.PERM_PROGRAM_MASTER,
      },
      {
        item: "Promo",
        pathname: "/masters/promo",
        permission: PAGE_PERMISSIONS.PERM_PROMO_MASTER,
      },
    ],
  },
  {
    item: "Account Managers",
    pathname: "/account-managers",
    permission: PAGE_PERMISSIONS.PERM_ACCOUNT_MANAGERS,
    subMenus: [],
  },
  {
    item: "User Management Menu",
    pathname: "/users",
    permission: PAGE_PERMISSIONS.PERM_USER_MANAGEMENT_MENU,
    subMenus: [],
  },
  {
    item: "Subscriptions Menu",
    pathname: "/subscriptions",
    permission: PAGE_PERMISSIONS.PERM_SUBSCRIPTION_MENU,
    subMenus: [
      {
        item: "Subscription Listing",
        pathname: "/subscriptions/listing",
        permission: PAGE_PERMISSIONS.PERM_SUBSCRIPTION_LISTING,
      },
      {
        item: "Create Subscription",
        pathname: "/subscriptions/new",
        permission: PAGE_PERMISSIONS.PERM_SUBSCRIPTION_CREATE,
      },
    ],
  },
  {
    item: "Query Support Menu",
    pathname: "/support",
    permission: PAGE_PERMISSIONS.PERM_QUERY_SUPPORT_MENU,
    subMenus: [],
  },
  {
    item: "Billing Menu",
    pathname: "/billing",
    permission: PAGE_PERMISSIONS.PERM_BILLING_MENU,
    subMenus: [
      {
        item: "Rate Card",
        pathname: "/billing/rate-card",
        permission: PAGE_PERMISSIONS.PERM_BILLING_RATE_CARD,
      },
      {
        item: "Billing Details",
        pathname: "/billing/listing",
        permission: PAGE_PERMISSIONS.PERM_BILLING_LISTING,
      },
    ],
  },
  {
    item: "Clients Menu",
    pathname: "/clients",
    permission: PAGE_PERMISSIONS.PERM_CLIENTS_MENU,
    subMenus: [
      {
        item: "Group Advertiser",
        pathname: "/clients/group-advertisers",
        permission: PAGE_PERMISSIONS.PERM_GROUP_ADVERTISER_MANAGE,
      },
      {
        item: "Groups",
        pathname: "/clients/groups",
        permission: PAGE_PERMISSIONS.PERM_GROUP_LISTING,
      },
      {
        item: "Clients",
        pathname: "/clients/all",
        permission: PAGE_PERMISSIONS.PERM_CLIENT_LISTING,
      },
      {
        item: "New Client",
        pathname: "/clients/new",
        permission: PAGE_PERMISSIONS.PERM_CREATE_CLIENT,
      },
      {
        item: "Renew Client",
        pathname: "/clients/renewList",
        permission: PAGE_PERMISSIONS.PERM_CLIENT_RE_LISTING,
      },
      {
        item: "",
        pathname: "/clients/grpRenewList",
        permission: PAGE_PERMISSIONS.GROUP_CLIENT_RENEW_LIST,
      }
    ],
  },
  {
    item: "File Details Menu",
    pathname: "/file",
    permission: PAGE_PERMISSIONS.PERM_FILE_DETAILS_MENU,
    subMenus: [],
  },
  {
    item: "Notification",
    pathname: "/notification",
    permission: PAGE_PERMISSIONS.PERM_NOTIFICATIONS,
    subMenus: [],
  },
  {
    item: "Activity Tracker Menu",
    pathname: "/activity",
    permission: PAGE_PERMISSIONS.PERM_ACTIVITY_TRACKER_MENU,
    subMenus: [],
  },
  {
    item: "Query Executor Menu",
    pathname: "/queryex",
    permission: PAGE_PERMISSIONS.PERM_QUERY_EXECUTOR_MENU,
    subMenus: [],
  },
];
